import type { Messages } from './en';

/**
 * Fase E (paquete hlcity): Hualien ciudad, mercado nocturno de Dongdamen, Pine Garden y Ji'an.
 * Las líneas de práctica de inglés se quedan en inglés a propósito.
 */
export const esHlcity: Pick<Messages, 'hlcity'> = {
  hlcity: {
    mapNames: { hlcity: 'Hualien ciudad' },
    zones: {
      hcStation: 'Estación de Hualien',
      hcCreative: 'Parque Cultural y Creativo',
      hcPine: 'Pine Garden (Songyuan)',
      hcMeilun: 'Río Meilun',
      hcSnacks: 'Calle de tentempiés del centro',
      hcIndigenous: 'Calle Indígena',
      hcMainland: 'Callejón del Continente',
      hcDongdamen: 'Mercado nocturno de Dongdamen',
      hcHotel: 'Hotel junto al mar',
      hcBike: 'Carril bici de la costa',
      hcBeibin: 'Parque Beibin',
      hcContainer: 'Container Coffee',
      hcQingxiu: 'Templo Qingxiu',
      hcPaddies: "Arrozales de Ji'an",
      hcJian: "Ji'an",
      hlcity: 'Hualien ciudad',
    },
    objects: {
      hc_shuttle: 'Parada del Tourist Shuttle',
      hc_mural: 'Mural amis',
      hc_shrine: 'Altar del Dios de la Tierra',
      hc_marketMap: 'Mapa del mercado nocturno',
      hc_dumpling: 'Puesto de empanadillas',
      hc_beefNoodle: 'Puesto de sopa de fideos con ternera',
      hc_xlb: 'Puesto de xiaolongbao',
      hc_sausage: 'Puesto de salchichas a la brasa',
      hc_bamboo: 'Puesto de arroz en caña de bambú',
      hc_crafts: 'Artesanía amis',
      hc_icecream: 'Rollito de helado con cacahuete',
      hc_tea: 'Puesto de té de burbujas',
      hc_balloon: 'Dardos y globos',
      hc_creative: 'Cartel del Parque Cultural',
      hc_pineGarden: 'Piedra del Pine Garden',
      hc_riverMouth: 'Mirador de la desembocadura',
      hc_bikePath: 'Cartel del carril bici',
      hc_seafront: 'Prismáticos del paseo marítimo',
      hc_container: 'Carta del Container Coffee',
      hc_photo: 'Rincón para fotos',
      hc_temple: 'Sala del templo Qingxiu',
      hc_buddha88: 'Los 88 Budas',
      hc_paddy: 'Cartel del arrozal',
      hc_store: 'Tienda Good Neighbor',
    },
    npc: {
      hc_stationStaff: 'Empleada de la estación',
      hc_taxiDriver: 'Taxista',
      hc_shuttleGuide: 'Guía del autobús turístico',
      hc_dumplingGrandpa: 'El abuelo de las empanadillas',
      hc_sausageVendor: 'El tío de las salchichas',
      hc_amisGrandma: 'Abuela amis',
      hc_balloonVendor: 'La señora de la caseta',
      hc_singer: 'Cantante del mercado',
      hc_cyclist: 'Ciclista',
      hc_jogger: 'Corredora',
      hc_barista: 'Barista',
      hc_caretaker: 'Cuidador del templo',
      hc_pineGuide: 'Guía del Pine Garden',
      hc_farmer: 'Agricultor de arroz',
    },
    items: {},

    closed: 'El puesto está tapado con una lona. El mercado nocturno de Dongdamen abre a las 5 de la tarde: ¡vuelve esta noche!',
    stampHint: 'Tu primer bocado en Dongdamen: ¡un sello nuevo en el pasaporte!',
    look: '👀 Solo mirar',
    back: '↩️ Volver',

    // Comida pedida en inglés (vendor, ok y bad son práctica de inglés).
    food: {
      dumpling: { vendor: 'Pork dumplings, boiled fresh! Ten or twenty?', ok: 'Ten dumplings, please. With soy sauce.', bad: ['Dumplings. Hundred. Go.', 'I am a dumpling, please.'], done: 'Diez empanadillas jugosas, recién sacadas de la olla. ¡Mojas, soplas y a la boca!', price: 40 },
      beefNoodle: { vendor: 'Beef noodle soup! Clear soup or red braised?', ok: 'Red braised, please. A small bowl.', bad: ['Noodle! Beef! Fast!', 'Cow soup for one cow.'], done: 'Ternera tierna, fideos elásticos y un caldo oscuro y sabroso. El abuelo aprendió la receta de su padre.', price: 60 },
      xlb: { vendor: 'Xiaolongbao! Soup inside — be careful, it’s hot!', ok: 'One basket, please. Thank you!', bad: ['Give me hot soup balls.', 'Basket. Now. Me.'], done: 'Le das un mordisquito, sorbes la sopa y luego te comes la empanadilla. ¡Mmm!', price: 50 },
      sausage: { vendor: 'Grilled pork sausage with garlic! Small or big?', ok: 'One small sausage, please.', bad: ['Sausage. Biggest. Free.', 'I want a sausage tree.'], done: 'Ahumada, dulce y jugosa: la salchicha se asa sobre carbón. ¡El tentempié favorito de la Calle Indígena!', price: 30 },
      bamboo: { vendor: 'Bamboo-tube rice! Sticky rice cooked inside bamboo.', ok: 'Could I have one, please? It smells great!', bad: ['Bamboo. Eat. Me.', 'One panda, please.'], done: 'El señor abre la caña de bambú: el arroz es pegajoso y huele a bosque. Las familias amis lo cocinan en las fiestas.', price: 45 },
      crafts: { vendor: 'Handmade bracelets! Glass beads in many colours.', ok: 'Could I have the red one, please? It’s beautiful.', bad: ['Bracelet. Cheap. Now.', 'Give me all the beads.'], done: 'La abuela te ata la pulsera en la muñeca. «El rojo es fuerza y alegría», te dice sonriendo.', price: 20 },
      icecream: { vendor: 'Peanut ice-cream roll! With coriander or without?', ok: 'Without coriander, please. One roll.', bad: ['Ice cream. Wrap. Fast.', 'Coriander only, no ice cream.'], done: 'Turrón de cacahuete rallado y dos bolas de helado envueltos en una crepe finita. ¡Crujiente y fresquito!', price: 35 },
      tea: { vendor: 'Bubble tea! Sugar level and ice level?', ok: 'Half sugar, less ice, please.', bad: ['Tea. Bubbles. Max.', 'All the sugar in the world.'], done: 'Perlas de tapioca blanditas y un té con leche cremoso. ¡Con la mitad de azúcar está perfecto!', price: 30 },
      container: { vendor: 'Welcome to Container Coffee! What would you like?', ok: 'Can I have a small hot chocolate, please?', bad: ['Chocolate. Hot. Give.', 'I want the whole container.'], done: 'Una taza calentita con una olita dibujada en la espuma. Te la tomas mirando los contenedores apilados.', price: 30 },
      store: { vendor: 'Welcome! Hot tea eggs and baked sweet potatoes today.', ok: 'One tea egg, please. How much is it?', bad: ['Egg. Tea. Money no.', 'One store, please.'], done: 'El huevo de té es marrón y jaspeado, cocido a fuego lento con té y especias. ¡Todas las tiendas 24 horas de Taiwán tienen una olla!', price: 12 },
    },

    // Lugares.
    shuttle: 'Aquí para el Taiwan Tourist Shuttle: autobuses a la Garganta de Taroko y a la playa de Qixingtan.',
    mural: 'El mural de la estación muestra dibujos amis: rojo para la fuerza, rombos blancos y amarillo para el sol. Los amis son el pueblo indígena más grande de Taiwán, y muchos viven cerca de Hualien.',
    muralQ: 'What do the Amis celebrate every summer?',
    muralA: ['The harvest festival', 'A snow festival', 'Halloween'],
    muralRight: '¡Sí! La fiesta de la cosecha (Ilisin): cantan y bailan en un gran círculo para dar las gracias por el año.',
    muralWrong: 'No exactamente. Fíjate en los bailarines que se dan la mano en el mural…',
    shrine: 'Un pequeño altar al Dios de la Tierra (土地公), que cuida del barrio. Por la mañana, los tenderos le traen fruta y encienden incienso.',
    shrineEn: 'Please keep our street safe.', // English practice
    pray: '🙏 Juntar las manos',
    prayed: 'Haces tres reverencias. El humo del incienso sube en espiral hacia el cielo.',
    marketMap: 'Mercado nocturno de Dongdamen (東大門夜市): un mercado enorme formado por cuatro antiguos. Calle Indígena, Callejón del Continente, puestos de Fuding y Ziqiang, juegos y música en directo. Abre cada tarde de 5 a 12 de la noche.',
    marketQ: 'When does the night market open?',
    marketA: ['At five p.m.', 'At five a.m.', 'At twelve noon'],
    marketRight: '¡Correcto! A las cinco de la tarde se encienden las luces y el humo de las parrillas lo llena todo.',
    marketWrong: 'Mmm, vuelve a mirar el horario en el mapa.',
    balloon: '¡Revienta los globos con dardos! Cinco dardos por 10 monedas.',
    play: '🎯 Jugar (10 monedas)',
    balloonQ: 'How many balloons did you pop?',
    balloonRight: '¡Bien contado! La señora te da una pegatina de premio.',
    balloonWrong: '¡Vuelve a contar los 💥!',
    nums: ['zero', 'one', 'two', 'three', 'four', 'five'],
    popped: (n: string) => `I popped ${n} balloons!`, // English practice
    creative: 'Este parque era la bodega de Hualien, construida en la época japonesa hace unos cien años. Hoy los viejos almacenes acogen exposiciones, tiendecitas y conciertos.',
    creativeLook: '🏭 Asomarse a un almacén',
    creativeDone: 'Dentro: cuadros de artistas de la zona, un pequeño escenario y olor a madera vieja y a vino de arroz de hace mucho tiempo.',
    creativeEn: 'This used to be a winery. Now it is an art park.', // English practice
    pine: 'Pine Garden (松園別館), 1942: un edificio blanco de dos plantas de la época japonesa, con soportales, en una colina entre pinos de Ryukyu de más de cien años. Antes fue una oficina del ejército; hoy es un espacio de arte y poesía con vistas al río Meilun y al Pacífico.',
    pineQ: 'What kind of trees grow around the Pine Garden?',
    pineA: ['Pine trees', 'Palm trees', 'Apple trees'],
    pineRight: 'Sí: pinos de Ryukyu muy viejos, retorcidos por el viento del mar.',
    pineWrong: 'Vuelve a mirar el nombre: 松 significa “pine” (pino).',
    riverMouth: 'Aquí el río Meilun (美崙溪) se encuentra con el océano Pacífico. Los pescadores esperan en el banco de arena y las garcetas pescan en el agua poco profunda.',
    riverEn: 'The river meets the sea.', // English practice
    lookAround: '🔭 Mirar por los prismáticos',
    lookedRiver: 'Ves el puerto, la desembocadura y, a lo lejos, las montañas verdes que caen sobre el mar azul.',
    bikePath: 'El carril bici de la costa va junto al mar desde el río Meilun hasta el sur de la ciudad. Al amanecer, la gente pasea en bici, corre y saca a sus perros.',
    bikeQ: '¿Qué dices cuando adelantas a alguien en bici? (práctica de inglés)',
    bikeA: ['Excuse me, on your left!', 'Move, move!', 'Goodbye forever!'],
    bikeRight: '¡Perfecto! Educado y claro. ¡Y toca el timbre!',
    bikeWrong: 'Eso no es muy amable. ¡Prueba otra vez!',
    seafront: 'El parque Beibin mira al Pacífico. Las mañanas despejadas, el sol sale del mar y a veces se ven barcas de pesca volviendo al puerto.',
    seaEn: 'The sun rises over the Pacific Ocean.', // English practice
    listen: '🌊 Escuchar las olas',
    listened: 'Shhh… fiuuu… Los guijarros ruedan adelante y atrás con cada ola.',
    photo: 'El Container Coffee está hecho con 29 contenedores de barco viejos, apilados y sobresaliendo como piezas gigantes de construcción. Por sus extremos de cristal entra la luz.',
    photoHow: 'Pide a alguien que pase que te haga una foto. ¿Qué le dices? (práctica de inglés)',
    photoA: ['Could you take a photo of me, please?', 'Photo me. Now.', 'Take my camera away!'],
    photoRight: '¡Clic! Una foto perfecta con los contenedores de colores detrás.',
    photoWrong: 'Mmm, prueba una forma más educada.',
    temple: 'El templo Qingxiu (慶修院) lo construyeron en 1917 unos agricultores japoneses que vivían en Ji’an. Con su sala de madera y sus farolillos de piedra, es uno de los templos japoneses mejor conservados de Taiwán.',
    templeEn: 'This temple is more than one hundred years old.', // English practice
    wish: '🔔 Tocar la campana y pedir un deseo',
    wished: 'Gonnng… El sonido grave recorre el jardín. Cierras los ojos y pides un deseo.',
    buddha: 'A lo largo del camino hay estatuas de Buda de piedra, una por cada templo de una famosa peregrinación en la isla de Shikoku, en Japón. Pasar por delante de todas es como hacer una peregrinación en miniatura.',
    buddhaQ: 'How many stone Buddhas are there?',
    buddhaA: ['Eighty-eight', 'Eighteen', 'Eight hundred'],
    buddhaRight: '¡Sí, 88! Cuatro filas a cada lado del camino.',
    buddhaWrong: 'Vuelve a contar: cuatro filas de once a cada lado…',
    paddy: 'Los arrozales de Ji’an se inundan con agua limpia de la montaña. Las garcetas caminan entre las plantas de arroz buscando ranas y peces.',
    paddyQ: 'What do farmers grow in these fields?',
    paddyA: ['Rice', 'Ice', 'Rocks'],
    paddyRight: '¡Correcto! Verde en primavera y dorado en otoño.',
    paddyWrong: 'Fíjate bien en las plantas del agua…',
    singer: 'Un cantante con guitarra canta canciones taiwanesas antiguas y éxitos nuevos. Entre los puestos, la gente da palmas.',
    clap: '👏 Dar palmas',
    clapped: 'Todo el mundo canta el estribillo a la vez. ¡El cantante te saluda con la mano!',
    singerEn: 'Thank you, Hualien! One more song?', // English practice
    shuttleRide: '🚌 Coger el autobús turístico',
    taxiEn: 'Could you take me to Dongdamen Night Market, please?', // English practice
    taxiQ: '¿Cómo se lo pides al taxista con educación? (práctica de inglés)',
    taxiA: ['Could you take me to Dongdamen Night Market, please?', 'Dongdamen. Drive.', 'Where is my taxi going?'],
    taxiRight: '“Sure! Seat belt on, please.” La próxima vez puedes ir andando: ¡está a solo diez minutos!',
    taxiWrong: 'Un poco borde… prueba con una pregunta educada.',

    // Personas: frases en el idioma del jugador y una frase en inglés cada una (práctica de inglés).
    talk: {
      hc_stationStaff: {
        lines: ['¡Bienvenido a Hualien! El Taroko Express desde Taipéi tarda unas dos horas.', 'Los trenes de vuelta salen del andén 1. ¡No pierdas el último de la tarde!', 'El tejado de la estación parece una montaña, y las columnas llevan dibujos amis.'],
        en: 'Welcome to Hualien! Enjoy your trip.', // English practice
      },
      hc_taxiDriver: {
        lines: ['¿Taxi? Hualien es pequeña: el mercado nocturno está a diez minutos.', 'Llevo veinte años de taxista aquí. ¡Conozco todos los restaurantes de fideos!', 'Los turistas siempre me piden ir a Taroko. ¡Coged el autobús turístico, que es más barato!'],
        en: 'Where would you like to go?', // English practice
      },
      hc_shuttleGuide: {
        lines: ['El autobús turístico verde va a la Garganta de Taroko y a la playa de Qixingtan.', 'Ten las monedas preparadas y siéntate a la derecha para ver el mar.', 'El último autobús vuelve antes de que anochezca.'],
        en: 'Does this bus go to Taroko Gorge?', // English practice
      },
      hc_dumplingGrandpa: {
        lines: ['Mi padre vino de Shandong. Estas empanadillas son su receta.', 'Este callejón se llama Callejón del Continente: comida de toda China.', 'Doblar, pellizcar, pellizcar, pellizcar… ¡Hago quinientas empanadillas cada noche!'],
        en: 'How many would you like?', // English practice
      },
      hc_sausageVendor: {
        lines: ['¡Bienvenido a la Calle Indígena! Nga’ay ho: así se dice «hola» en amis.', 'Arroz en bambú, salchichas a la brasa, pasteles de mijo… todo viene de la montaña y del mar.', 'Nuestros abuelos nos enseñaron a compartir la comida con todo el mundo.'],
        en: 'Nga’ay ho! Hello and welcome!', // English practice
      },
      hc_amisGrandma: {
        lines: ['Tejo estas pulseras a mano. Cada color tiene un significado.', 'El rojo es la fuerza, el blanco la pureza y el amarillo el sol.', 'Nuestra fiesta de la cosecha es en verano. ¡Baila todo el pueblo!'],
        en: 'Did you make this by hand?', // English practice
      },
      hc_balloonVendor: {
        lines: ['¡Cinco dardos, diez monedas! ¡Revienta tres globos y ganas un premio!', 'Apunta al centro y lanza suave.', '¡Muchas veces los niños lo hacen mejor que sus padres!'],
        en: 'Ready? Aim… throw!', // English practice
      },
      hc_singer: {
        lines: ['Canto aquí todas las noches. ¿Te sabes alguna canción?', 'Esta es una vieja canción de amor de Hualien.', '¡Da palmas conmigo en el estribillo!'],
        en: 'Thank you, Hualien! One more song?', // English practice
      },
      hc_cyclist: {
        lines: ['Recorro el carril de la costa cada mañana. El mar es distinto cada día.', 'Desde aquí puedes llegar pedaleando hasta el sur de la ciudad.', '¡Ponte el casco y toca el timbre!'],
        en: 'On your left!', // English practice
      },
      hc_jogger: {
        lines: ['¡Buenos días! El paseo del río es perfecto para correr.', 'Hoy he visto una garza junto a la desembocadura.', '¡Corre, respira y sonríe!'],
        en: 'Good morning! Lovely day, isn’t it?', // English practice
      },
      hc_barista: {
        lines: ['¡Bienvenido a Container Coffee! Arriba están las mejores vistas.', 'Los contenedores sobresalen para que su sombra cubra la terraza.', 'Nuestro chocolate caliente es el favorito de los niños.'],
        en: 'What size would you like: small, medium or large?', // English practice
      },
      hc_caretaker: {
        lines: ['Cada mañana barro el camino de piedra, pasando por delante de los 88 Budas.', 'Unos agricultores japoneses construyeron este templo cuando el pueblo se llamaba Yoshino.', 'Camina en silencio y haz una pequeña reverencia ante la sala.'],
        en: 'Please walk quietly in the temple.', // English practice
      },
      hc_pineGuide: {
        lines: ['Estos pinos de Ryukyu tienen más de cien años.', 'Desde el balcón se ve cómo el río se encuentra con el océano.', 'Aquí vienen poetas a escribir. ¿Leemos un poema?'],
        en: 'The view from the top is beautiful.', // English practice
      },
      hc_farmer: {
        lines: ['El arroz de Ji’an crece con agua limpia de la Cordillera Central.', 'Las garcetas son mis ayudantes: ¡se comen los bichos!', 'Dos cosechas al año: una en verano y otra en otoño.'],
        en: 'The rice is green now. In autumn it turns gold.', // English practice
      },
    },
  },
};
